import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as GroupsAction } from '../../actions/groupDashboard/groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as IdealistDayEventsAction } from '../../actions/groupDashboard/idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as ListingsAction } from '../../actions/groupDashboard/listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as SearchAction } from '../../actions/groupDashboard/search';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groups from './groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents from './idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import search from './search';

export default combineReducers<
  {
    groups: typeof groups;
    idealistDayEvents: typeof idealistDayEvents;
    listings: typeof listings;
    search: typeof search;
  },
  GroupsAction | IdealistDayEventsAction | ListingsAction | SearchAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  groups,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => { byGroupI... Remove this comment to see the full error message
  idealistDayEvents,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search,
});
